module.exports = __webpack_public_path__ + "img/fondo-banner-principal.0e46da8e.png";